import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  showErrorAlert,
  showSuccessAlert,
  showSuccessEditAlert,
} from "../../../components/alerts";
import medicGeekApi from "../../../config/axiosConfig";
import "./../../../styles/FormPro.css";

const SegurosList = ({ currentForm }) => {
  const [seguros, setSeguros] = useState([]);
  const [showForm] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const segurosPerPage = 10;
  const [selectedSeguroLocal, setSelectedSeguroLocal] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Skeleton
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const [formulario, setFormulario] = useState({
    nombreSeguro: "",
    descripcionSeguro: "",
    estatusSeguro: "activo",
  });

  const openModal = (seguro) => {
    setSelectedSeguroLocal(seguro); // Configura el seguro seleccionado para la edición

    if (seguro) {
      setIsEditing(true); // Establecer como modo edición cuando se abre el modal
      setFormulario({
        nombreSeguro: seguro.seguroNm,
        descripcionSeguro: seguro.seguroDesc,
        estatusSeguro: seguro.estatus ? "activo" : "inactivo",
      });
    } else {
      setIsEditing(false); // Establecer como modo creación cuando se abre el modal para crear uno nuevo
      // Limpia los campos si es necesario
      setFormulario({
        nombreSeguro: "",
        descripcionSeguro: "",
        estatusSeguro: "activo",
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedSeguroLocal(null); // Limpia el seguro seleccionado
    setIsEditing(false); // Resetear el modo edición cuando se cierra el modal
    setModalOpen(false);
  };

  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Iniciar la carga
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("Token not found");

        const response = await medicGeekApi.get(
          `/seguros?search=${searchTerm}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
          {
            params: {
              $or: [
                { seguroNm: { $regex: searchTerm, $options: "i" } },
                { seguroDesc: { $regex: searchTerm, $options: "i" } },
              ],
            },
          }
        );
        const sortedSeguros = response.data.sort(
          (a, b) => a.seguroId - b.seguroId
        );
        setSeguros(sortedSeguros);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Finalizar carga
      }
    };

    fetchData();
  }, [searchTerm]);

  const pageCount = Math.ceil(seguros.length / segurosPerPage);

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const displayedSeguros = seguros
    .filter((seguro) => {
      // Filtrar seguros basados en el término de búsqueda
      return (
        seguro.seguroNm.toLowerCase().includes(searchTerm.toLowerCase()) ||
        seguro.seguroDesc.toLowerCase().includes(searchTerm.toLowerCase())
      );
    })
    .slice(pageNumber * segurosPerPage, (pageNumber + 1) * segurosPerPage);

  const updateSegurosList = () => {
    medicGeekApi
      .get("/seguros")
      .then((response) => {
        setSeguros(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const guardarNuevoSeguro = () => {
  const nuevoSeguro = {
    seguroNm: document.getElementById("nombreSeguro").value,
    seguroDesc: document.getElementById("descripcionSeguro").value,
    estatus:
      document.getElementById("estatusSeguro").value === "activo"
        ? "Activo"
        : "Inactivo",
  };

  console.log("Payload enviado:", nuevoSeguro);

  medicGeekApi
    .post("/seguros", nuevoSeguro)
    .then((response) => {

      console.log("Respuesta backend:", response.data);

      showSuccessAlert();
      closeModal();
      updateSegurosList();
    })
    .catch((error) => {
      console.error(
        "Error al crear el seguro",
        error.response?.data || error
      );
    });
};
  const editarSeguro = () => {
    if (selectedSeguroLocal && selectedSeguroLocal.seguroId) {
      const { seguroId } = selectedSeguroLocal;
      const nombreSeguro = document.getElementById("nombreSeguro").value;
      const descripcionSeguro =
        document.getElementById("descripcionSeguro").value;
      const estatusSeguro =
        document.getElementById("estatusSeguro").value === "activo"
          ? "Activo"
          : "Inactivo";

      const updatedSeguro = {
        seguroId, // Asegurarse de enviar el ID
        seguroNm: nombreSeguro,
        seguroDesc: descripcionSeguro,
        estatus: estatusSeguro,
      };

      medicGeekApi
        .patch(`/seguros/${seguroId}`, updatedSeguro)
        .then((response) => {
          showSuccessEditAlert();
          closeModal();
          updateSegurosList();
        })
        .catch((error) => {
          console.error("Error al actualizar el seguro", error);
        });
    } else {
      // Manejo de error o mensaje de que no se puede actualizar
      showErrorAlert("No se puede actualizar: seguro no válido.");
    }
  };

  const SkeletonTableRow = () => (
    <tr>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "70px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "200px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}
        ></div>
      </td>
      <td>
        <div
          className="skeleton-placeholder"
          style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}
        ></div>
      </td>
    </tr>
  );

  return (
  <div className="pro-container">

    {/* ===================================================== */}
    {/* HEADER */}
    {/* ===================================================== */}

    <div className="pro-header">

      <div className="pro-header-left">

        <h2 className="pro-title">
          Seguros
        </h2>

        <p className="pro-subtitle">
          Gestión y administración de seguros médicos
        </p>

      </div>

      <div className="pro-actions">

        {/* SEARCH */}
        <div className="pro-search">

          <i className="bi bi-search"></i>

          <input
            type="search"
            placeholder="Buscar seguro..."
            aria-label="Buscar"
            value={searchTerm}
            onChange={handleSearchTermChange}
          />

        </div>

        {/* BUTTON */}
        <button
          type="button"
          className="pro-btn-primary"
          title="Crear Nuevo Seguro"
          onClick={() => openModal(null)}
        >

          <i className="bi bi-file-plus-fill"></i>

          Nuevo Seguro

        </button>

      </div>

    </div>

    {/* ===================================================== */}
    {/* TABLE DESKTOP */}
    {/* ===================================================== */}

    <div className="pro-card d-none d-md-block">

      <div className="table-responsive">

        <table className="table pro-table align-middle">

          <thead>

            <tr>

              <th style={{ width: "10%" }}>
                ID
              </th>

              <th style={{ width: "30%" }}>
                Nombre del Seguro
              </th>

              <th style={{ width: "35%" }}>
                Descripción
              </th>

              <th
                style={{ width: "10%" }}
                className="text-center"
              >
                Estado
              </th>

              <th
                style={{ width: "15%" }}
                className="text-center"
              >
                Acciones
              </th>

            </tr>

          </thead>

          <tbody>
            {loading ? (
              Array.from({ length: 12 }).map((_, index) => (
                <tr key={index}>
                  <td>
                    <div className="skeleton-line"></div>
                  </td>
                  <td>
                    <div className="skeleton-line"></div>
                  </td>
                  <td>
                    <div className="skeleton-line"></div>
                  </td>
                  <td>
                    <div className="skeleton-line"></div>
                  </td>
                  <td>
                    <div className="skeleton-line"></div>
                  </td>
                </tr>
              ))
            ) : (
              displayedSeguros.map((seguro) => (
                <tr key={seguro.seguroId}>
                  {/* ID */}
                  <td>
                    <span className="expediente-badge">
                      #
                      {seguro.seguroId}
                    </span>
                  </td>
                  {/* NAME */}
                  <td>
                    <div className="patient-info">
                      <div className="patient-avatar">
                        {seguro.seguroNm?.charAt(0)}
                      </div>
                      <div>
                        <div className="patient-name">
                          {seguro.seguroNm}
                        </div>
                        <div className="patient-id">
                          Seguro Médico
                        </div>
                      </div>
                    </div>
                  </td>
                  {/* DESCRIPTION */}
                  <td
                    className="truncate-text"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={seguro.seguroDesc}
                  >
                    {seguro.seguroDesc?.length > 40
                      ? `${seguro.seguroDesc.slice(0, 40)}...`
                      : seguro.seguroDesc}
                  </td>
                  {/* STATUS */}
                  <td className="text-center">
                    <span
                      className={`gender-badge ${
                        seguro.estatus === "Activo"
                          ? ""
                          : "bg-danger-subtle text-danger"
                      }`}
                    >
                      {seguro.estatus}
                    </span>
                  </td>
                  {/* ACTIONS */}
                  <td>
                    <div className="pro-table-actions">
                      {/* EDIT */}
                      <button
                        type="button"
                        className="pro-action-btn warning"
                        title="Editar"
                        onClick={() => openModal(seguro)}
                      >
                        <i className="bi bi-pencil-square"></i>
                      </button>
                      {/* DELETE */}
                      <button
                        type="button"
                        className="pro-action-btn info"
                        title="Eliminar"
                        // onClick={() => handleDelete(seguro.seguroId)}
                      >
                        <i className="bi bi-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>

        </table>

      </div>

    </div>

    {/* ===================================================== */}
    {/* MOBILE CARDS */}
    {/* ===================================================== */}

    <div className="d-md-none">

      <div className="row g-3">

        {loading ? (

          Array.from({ length: 5 }).map((_, index) => (

            <div
              className="col-12"
              key={index}
            >

              <div className="mobile-patient-card">

                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line"></div>

              </div>

            </div>

          ))

        ) : (

          displayedSeguros.map((seguro) => (

            <div
              className="col-12"
              key={seguro.seguroId}
            >

              <div className="mobile-patient-card">

                {/* TOP */}
                <div className="mobile-card-top">

                  <div className="patient-info">

                    <div className="patient-avatar">

                      {seguro.seguroNm?.charAt(0)}

                    </div>

                    <div>

                      <div className="patient-name">

                        {seguro.seguroNm}

                      </div>

                      <div className="patient-id">

                        ID #{seguro.seguroId}

                      </div>

                    </div>

                  </div>

                </div>

                {/* CONTENT */}
                <div className="mobile-card-content">

                  <p>

                    <strong>
                      Descripción:
                    </strong>

                    <br />

                    {seguro.seguroDesc}

                  </p>

                  <p>

                    <strong>
                      Estado:
                    </strong>

                    <br />

                    <span className="gender-badge">

                      {seguro.estatus}

                    </span>

                  </p>

                </div>

                {/* ACTIONS */}
                <div className="mobile-card-actions">

                  <button
                    type="button"
                    className="pro-action-btn warning"
                    title="Editar"
                    onClick={() => openModal(seguro)}
                  >

                    <i className="bi bi-pencil-square"></i>

                  </button>

                  <button
                    type="button"
                    className="pro-action-btn info"
                    title="Eliminar"
                    // onClick={() => handleDelete(seguro.seguroId)}
                  >

                    <i className="bi bi-trash"></i>

                  </button>

                </div>

              </div>

            </div>

          ))

        )}

      </div>

    </div>

    {/* ===================================================== */}
    {/* PAGINATION */}
    {/* ===================================================== */}

    {!showForm && (

      <div className="pro-pagination">

        <nav>

          <ul className="pagination modern-pagination">

            {/* PREVIOUS */}
            <li
              className={`page-item ${
                pageNumber === 0
                  ? "disabled"
                  : ""
              }`}
            >

              <button
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber - 1,
                  })
                }
              >

                <i className="bi bi-chevron-left"></i>

              </button>

            </li>

            {/* NUMBERS */}
            {Array.from(
              {
                length: Math.min(pageCount, 10),
              },
              (_, index) => (

                <li
                  key={index}
                  className={`page-item ${
                    pageNumber === index
                      ? "active"
                      : ""
                  }`}
                >

                  <button
                    className="page-link"
                    onClick={() =>
                      handlePageChange({
                        selected: index,
                      })
                    }
                  >

                    {index + 1}

                  </button>

                </li>

              )
            )}

            {/* NEXT */}
            <li
              className={`page-item ${
                pageNumber === pageCount - 1
                  ? "disabled"
                  : ""
              }`}
            >

              <button
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber + 1,
                  })
                }
              >

                <i className="bi bi-chevron-right"></i>

              </button>

            </li>

          </ul>

        </nav>

      </div>

    )}

    {/* ===================================================== */}
    {/* MODAL */}
    {/* ===================================================== */}

    <Modal
      isOpen={modalOpen}
      toggle={closeModal}
      centered
      className="pro-modal"
    >

      <ModalHeader toggle={closeModal}>

        {isEditing
          ? "Editar Seguro"
          : "Crear Nuevo Seguro"}

      </ModalHeader>

      <ModalBody>

        <Form className="pro-form-layout">

          {/* NOMBRE */}
          <FormGroup floating>

            <Input
              type="text"
              id="nombreSeguro"
              className="pro-input"
              placeholder="Nombre del Seguro"
              value={formulario.nombreSeguro}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  nombreSeguro: e.target.value,
                })
              }
            />

            <Label for="nombreSeguro">
              Nombre del Seguro
            </Label>

          </FormGroup>

          {/* DESCRIPCION */}
          <FormGroup floating>

            <Input
              type="text"
              id="descripcionSeguro"
              className="pro-input"
              placeholder="Descripción"
              value={formulario.descripcionSeguro}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  descripcionSeguro: e.target.value,
                })
              }
            />

            <Label for="descripcionSeguro">
              Descripción
            </Label>

          </FormGroup>

          {/* ESTADO */}
          <FormGroup floating>

            <Input
              type="select"
              id="estatusSeguro"
              className="pro-input"
              value={formulario.estatusSeguro}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  estatusSeguro: e.target.value,
                })
              }
            >

              <option value="activo">
                Activo
              </option>

              <option value="inactivo">
                Inactivo
              </option>

            </Input>

            <Label for="estatusSeguro">
              Estado
            </Label>

          </FormGroup>

        </Form>

      </ModalBody>

      <ModalFooter className="border-0 pt-0">

        <Button
          className="pro-btn-cancel"
          onClick={closeModal}
        >

          Cancelar

        </Button>

        <Button
          className="pro-btn-save"
          onClick={
            isEditing
              ? editarSeguro
              : guardarNuevoSeguro
          }
        >

          {isEditing
            ? "Guardar Edición"
            : "Guardar"}

        </Button>

      </ModalFooter>

    </Modal>

  </div>
);
};
export default SegurosList;
